import { Grid, Link, Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';

interface IAppLabelWithValueProps {
  label: string;
  value: ReactNode;
}

const AppLabelWithValue: React.FC<IAppLabelWithValueProps> = (props) => {
  const { label, value } = props;
  const [expanded, setExpanded] = useState(false);
  const lines = 3;

  return (
    <>
      <Grid item xs={12} md={2}>
        <Typography variant="subtitle2" color="text.secondary" fontWeight={400}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={10}>
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: expanded ? 'unset' : lines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Typography>
        {typeof value === 'string' && value.length > 700 && (
          <Link
            component="button"
            variant="body2"
            onClick={() => setExpanded(!expanded)}
            sx={{ mt: 1, display: 'inline-block' }}
          >
            {expanded ? 'Show less' : 'Read more'}
          </Link>
        )}
      </Grid>
    </>
  );
};

export default AppLabelWithValue;
